export type PromiseFulfilled<T> = {
  status: 'fulfilled';
  value: T;
};

export type PromiseRejected = {
  status: 'rejected';
  reason: string;
};

export type PromiseAllSettledType<T> = PromiseFulfilled<T> | PromiseRejected;

/**
 * Promise.allSettled ponyfill
 */
export const allSettled = <T>(
  promises: Promise<T>[],
): Promise<PromiseAllSettledType<T>[]> => {
  return Promise.all(
    promises.map((p) => p.then(
      (value) => ({
        status: 'fulfilled' as const,
        value,
      }),
      (reason: string) => ({
        status: 'rejected' as const,
        reason,
      }),
    )),
  );
};
